import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import PlacementMessages from './placement-messages.js';

const { UIView } = MojitoCore.Presentation;

/**
 * View for displaying related placement messages.
 *
 * @class PlacementMessages
 * @memberof Mojito.Modules.BetslipView
 */

/**
 * PlacementMessages prop types.
 *
 * @property {Array<Mojito.Services.Betslip.types.Error>} [placementErrors = []] - An array of placement errors, typically multiplier errors.
 *
 * @memberof Mojito.Modules.BetslipView
 */
const propTypes = {
    placementErrors: PropTypes.array,
};

const defaultProps = {
    placementErrors: [],
};

export default UIView('PlacementMessages', PlacementMessages, propTypes, defaultProps);
